import { render, staticRenderFns } from "./IssueCommand.vue?vue&type=template&id=2a7de734&scoped=true&"
import script from "./IssueCommand.vue?vue&type=script&lang=js&"
export * from "./IssueCommand.vue?vue&type=script&lang=js&"
import style0 from "./IssueCommand.vue?vue&type=style&index=0&id=2a7de734&lang=scss&scoped=true&"
import style1 from "./IssueCommand.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7de734",
  null
  
)

export default component.exports